import React, { useEffect, useState } from "react";
import { URL } from "../utils/constants";
import cache from "../utils/cache";
import PDFLoader from './PDFLoader';
import { getEventCertificate } from "../services/eventService";

export default function Certificate() {
  const [certificate, setCertificate] = useState(null);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [certificateImage, setCertificateImage] = useState(null);
  /* useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const response = await getEventCertificate();
        console.log("response:", response);
        console.log("success:", response.success);
        console.log("message:", response.message);
        if (response.success === true) {
          setCertificate(response.data);
           document.body.classList.add("certificate-page");
        } else {
          setMessage(response.message);
        }
      } catch (error) {
        console.error("Certificate API error:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCertificate();
    return () => {
      document.body.classList.remove("certificate-page");
    };
  }, []); */


  useEffect(() => {
    const fetchCertificate = async () => {
      try {
        const response = await getEventCertificate();
        if (response.success === true) {
          setCertificate(response.data);
          document.body.classList.add("certificate-page");
          const imageCacheKey = "event-certificate-image";
          const cachedImage = await cache.get(imageCacheKey);
          if (cachedImage) {
            const imageUrl = window.URL.createObjectURL(cachedImage);
            setCertificateImage(imageUrl);
          } else {
            const imageUrl = `${URL}${response.data.url}`;
            const imageResponse = await fetch(imageUrl);
            if (imageResponse.ok) {
              const imageBlob = await imageResponse.blob();
              await cache.set(imageCacheKey, imageBlob, "30m");
              const objectUrl = window.URL.createObjectURL(imageBlob);
              setCertificateImage(objectUrl);
            }
          }
        } else {
          setMessage(response.message);
        }
      } catch (error) {
        console.error("Certificate API error:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCertificate();

    return () => {
      document.body.classList.remove("certificate-page");
    };
  }, []);

  const handleDownload = async () => {
    try {
      const response = await fetch(`${URL}${certificate.url}`);

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "certificate.jpg";

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download error:", error);
    }
  };





  return (
    <>
      <section className="certificate_box d-none">
        <div className="container">
          {isLoading ? (
            <div className="text-center">
              <PDFLoader />
            </div>
          ) : (
            <div className="row justify-content-center">
              {certificate ? (
                <div className="col-md-12 participated">
                  <img src={certificateImage} loading="eager" alt="Certificate Image" fetchPriority="high" />
                  <button className="btn-6 view-all-btnn mt-3" onClick={handleDownload}>Download Certificate</button>
                </div>
              ) : (
                <div className="col-lg-6 col-sm-6 not_participated">
                  <img className="certificate_icon" src={`${process.env.PUBLIC_URL}/assets/images/elements/certificate_icon.png`} alt="certificate icon" />
                  <p>{message}</p>
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      <section className="certificate_box">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8 participated ">
              The result will be announced soon...
            </div>

          </div>
        </div>
      </section>
    </>
  )
}
